// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"block_wrapper___rub_","copyCode":"block_copyCode__7qGDF","editor":"block_editor__bPjM1"};